// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+YLtq","paragraph":"styles_paragraph__Qgpzx"};